import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import AboutPage from './pages/AboutPage/AboutPage';
import ContactPage from './pages/ContactPage/ContactPage';
import HomePage from './pages/HomePage/HomePage';
import MorePage from './pages/MorePage/MorePage';
import RecipesPage from './pages/RecipesPage/RecipesPage';
import CartPage from './pages/CartPage/CartPage';
import AdminLoginPage from './pages/AdminLoginPage/AdminLoginPage';
import AdminPanel from './pages/AdminPanel/AdminPanel';
import SuperadminPanel from './pages/SuperadminPanel/SuperadminPanel';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Routes>
            {/* Admin login */}
            <Route path="/admin-login" element={<AdminLoginPage />} />
            
            {/* Admin panel as full-page (protected) */}
            <Route path="/admin" element={<ProtectedRoute element={<AdminPanel />} requiredRole="admin" />} />
            
            {/* Superadmin panel as full-page (protected) */}
            <Route path="/superadmin" element={<ProtectedRoute element={<SuperadminPanel />} requiredRole="superadmin" />} />
            
            {/* Main layout routes */}
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/recipes" element={<RecipesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/more" element={<MorePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
